// extracted by mini-css-extract-plugin
export default {"header":"ClubForum_header__6a7s9","clubHeader":"ClubForum_clubHeader__ydQgd","forumHeader":"ClubForum_forumHeader__Q59OB","icon":"ClubForum_icon__3Y6sW"};